// Firebase App (the core Firebase SDK) is always required and must be listed first
import { initializeApp, FirebaseApp } from "firebase/app";
import { getAuth, onAuthStateChanged, User } from "firebase/auth";

let firebaseApp: FirebaseApp | null = null;

export async function initFirebase() {
  const config = {
    apiKey: import.meta.env.VITE_FIREBASE_API_KEY,
    authDomain: import.meta.env.VITE_FIREBASE_AUTH_DOMAIN,
    projectId: import.meta.env.VITE_FIREBASE_PROJECT_ID,
    storageBucket: import.meta.env.VITE_FIREBASE_STORAGE_BUCKET,
    messagingSenderId: import.meta.env.VITE_FIREBASE_MESSAGING_SENDER_ID,
    appId: import.meta.env.VITE_FIREBASE_APP_ID,
    measurementId: import.meta.env.VITE_FIREBASE_MEASUREMENT_ID
  };
  firebaseApp = initializeApp(config);

  // Trigger an auth rehydration uupfront
  const auth = getAuth();
  await new Promise((resolve) => {
    const handler = (user: User | null) => {
      resolve(user);
      unsub();
    };
    const unsub = onAuthStateChanged(auth, handler);
  });

  return firebaseApp;
}

export function getFirebase() {
  if (!firebaseApp) {
    initFirebase();
  }
  return firebaseApp;
}
